import { ComponentType } from 'react';

import HomePage from 'pages/Home';
import { Rewards } from 'pages/Rewards';
import { AccountPage } from 'pages/Account';

import { AppRoute } from '../config';

import { ExchangeCode } from 'pages/Auth/ExchangeCode';
import { ForgotPassword } from 'pages/Auth/ForgotPassword';

// This CANT live together inside the config/routes.ts config file
// as it would cause circular dependencies => vite HMR would not work at all
export const routeComponents: Record<AppRoute, ComponentType> = {
  auth: ExchangeCode,
  'forgot-password': ForgotPassword,

  home: HomePage,
  account: AccountPage,
  reward: Rewards,
};
